import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { updateTailoredAuditRejection } from "./controller/update-tailored-audit-rejection"
import { successSnackbar } from "lib/snackbar/success-snackbar"

export function RemoveRejection() {
    const { rejection, setRejection, tailoringAudit, setTailoringAudit } = useBoundContext()

    return (
        <If truthy={rejection?.reason}>
            <Button
                startIcon={<Iconify icon="mdi:bin" />}
                onClick={handleRemove}
                color="error"
                data-cy="remove-rejection-button"
            >
                Remove
            </Button>
        </If>
    )

    async function handleRemove() {
        if (
            await confirm(
                "This action is permanent and can't be undone. The rejection will be permanently deleted.",
                "Delete Rejection",
                undefined,
                "Delete"
            )
        ) {
            const cleared = await updateTailoredAuditRejection(tailoringAudit.id, "")
            // Show the removal immediately rather than after the invalidation refetch (FIQ-682)
            if (cleared && typeof cleared === "object") {
                setTailoringAudit?.(cleared)
            }
            setRejection(null)
            successSnackbar("Successfully removed rejection")
        }
    }
}
